import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import { type Table } from '@tanstack/react-table'

import { Button } from '@/components/ui/button/button'
import { Select } from '@/components/ui/select/select'

import { cx } from '@/libs/cva'

interface DataTablePaginationProps<TData> {
	table: Table<TData>
	pageSizeOptions?: number[]
	disableRowSelection?: boolean
}

export function DataTablePagination<TData>({
	table,
	pageSizeOptions = [10, 20, 30, 40, 50],
	disableRowSelection = false,
}: DataTablePaginationProps<TData>) {
	return (
		<div
			className={cx(
				'txt-compact-small-plus flex w-full items-center justify-between px-6 py-4 text-ui-fg-subtle'
			)}
		>
			<div className="text-muted-foreground flex-1 whitespace-nowrap text-sm">
				{!disableRowSelection && (
					<>
						{table.getFilteredSelectedRowModel().rows.length} of{' '}
						{table.getFilteredRowModel().rows.length} row(s) selected.
					</>
				)}
			</div>
			<div className="ml-auto flex flex-col-reverse items-center gap-4 sm:flex-row sm:gap-6 lg:gap-8">
				<div className="flex items-center space-x-2">
					<p className="whitespace-nowrap text-sm font-medium">Rows per page</p>
					<Select
						value={`${table.getState().pagination.pageSize}`}
						onValueChange={(value) => {
							table.setPageSize(Number(value))
						}}
						size="small"
					>
						<Select.Trigger>
							<Select.Value
								placeholder={table.getState().pagination.pageSize}
							/>
						</Select.Trigger>
						<Select.Content side="top">
							{pageSizeOptions.map((pageSize) => (
								<Select.Item key={pageSize} value={`${pageSize}`}>
									{pageSize}
								</Select.Item>
							))}
						</Select.Content>
					</Select>
				</div>
				<div className="flex items-center justify-center text-sm font-medium">
					Page {table.getState().pagination.pageIndex + 1} of{' '}
					{table.getPageCount()}
				</div>
				<div className="flex items-center space-x-2">
					{/* <Button
            aria-label="Go to first page"
            variant="secondary"
            className="hidden size-8 p-0 lg:flex"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            <DoubleArrowLeftIcon className="size-4" aria-hidden="true" />
          </Button> */}
					<Button
						aria-label="Go to previous page"
						variant="secondary"
						size="icon"
						className="size-6"
						onClick={() => table.previousPage()}
						disabled={!table.getCanPreviousPage()}
					>
						<ChevronLeftIcon className="size-4" aria-hidden="true" />
					</Button>
					<Button
						aria-label="Go to next page"
						variant="secondary"
						size="icon"
						className="size-6"
						onClick={() => table.nextPage()}
						disabled={!table.getCanNextPage()}
					>
						<ChevronRightIcon className="size-4" aria-hidden="true" />
					</Button>
					{/* <Button
            aria-label="Go to last page"
            variant="secondary"
            size="icon"
            className="hidden size-8 lg:flex"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            <DoubleArrowRightIcon className="size-4" aria-hidden="true" />
          </Button> */}
				</div>
			</div>
		</div>
	)
}
